<template>
  <div class="messageBox sub-main" v-loading="loading">
    <div v-if="stateFlag">
      <div style="margin: 5px">
        <el-input
          style="width: 300px"
          placeholder="请输入店铺名称"
          v-model="shopName"
        >
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
        <el-divider></el-divider>
        <el-table 
        :header-cell-style="{
          background: '#F2F6FC',
          color: '#525A6E',
          height: '40px',
        }" stripe :data="tableData" border style="width: 100%">
          <el-table-column label="店铺名称">
            <template slot-scope="scope">
              <span>{{ scope.row.shopName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="授信额度">
            <template slot-scope="scope">
              <span style="color: #ff4747">{{ scope.row.creditAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="待还金额">
            <template slot-scope="scope">
              <span style="color: #ff4747">{{ scope.row.payBackAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="可用金额">
            <template slot-scope="scope">
              <span style="color: #ff4747">{{ scope.row.balanceAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="授信状态" min-width="100">
          <template slot-scope="scope">
            
            <el-tag size="small" type="success" v-if="scope.row.creditState == 1"
              >启用</el-tag
            >
            <el-tag size="small" type="warning" v-else-if="scope.row.creditState == 2"
              >终止</el-tag
            >
            <el-tag size="small" type="danger" v-else-if="scope.row.creditState == 0"
              >冻结</el-tag
            >
          </template>
        </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button class="btn" size="small" @click="billItem(scope.row)"
                >账单记录</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        style="margin-top: 30px"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="page"
        @current-change="handleCurrentChange"
        :total="total"
      >
      </el-pagination>
    </div>
    <div v-else>
        <billItem :stateFlag ="stateFlag" :rowData="rowdata" @func="getFlag"></billItem>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
import { mapGetters, mapMutations } from "vuex";
import billItem from '@/views/userCenter/billPayServer/billItem'
export default {
  name: "billPayServer",
  mixins: [listSearchMixin],
  components:{
      billItem
  },
  data() {
    return {
        stateFlag:true,
        rowdata:'',
      tableData: [
       
      ],
      messageList: [],
      page: 1,
      pageSize: 10,
      shopName:"",
      total: 1,
      flag: true,
      loading: false,
      payBackMoney:{}
    };
  },
  mounted() {
    this.getAll();
    this.getUserInfo();
  },
  computed: {
    ...mapGetters([
      "userInfo", // 用户信息
    ]),
    
  },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO",
    }),
    billItem(row){
        this.stateFlag = false
        this.rowdata = row
    },
    getFlag(data){
        this.stateFlag = data
        console.log(data)
    },
    search(){
      this.getAll()
    },
    // 获取授信列表
    getAll() {
      let self = this;
      // const rLoading = this.openLoading()
      self.loading = true;
      let params = {
        url: api.creditList ,
        method: "post",
        data: {
          page: self.page,
	        pageSize: self.pageSize,
	        shopName: self.shopName
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          this.payBackMoney = res.data.credit
          this.tableData = res.data.list;
          this.total = res.data.total;
          if (res.data.list.length) {
            this.flag = true;
          } else {
            this.flag = false;
          }
          // rLoading.close()
          self.loading = false;
        } else {
          this.$message.warning(res.message);
          self.loading = false;
        }
      });
    },
    // 获取用户信息
    getUserInfo() {
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      self.sendReq(params, (res) => {
        
        if (res.code === "200") {
          self.setUserInfo(res.data);
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    
    // 翻页
    handleCurrentChange(val) {
      this.page = val;
      this.getAll();
    },
    // 查看详情
    goToDetail(item) {
      if (item.noticeType === 1) {
        if (item.jump === 0) {
          this.$router.push({
            path: "/notificationDetails",
            query: {
              id: item.noticeId,
            },
          });
        } else if (item.jump === 1) {
          this.$router.push({
            path: "/notificationDetails",
            query: {
              id: item.noticeId,
            },
          });
        } else if (item.jump === 2) {
          this.$router.push({
            path: "/orderDetail",
            query: {
              orderId: item.only,
              noticeId: item.noticeId,
            },
          });
        }
      } else if (item.noticeType === 3) {
        this.$router.push({
          path: "/notificationDetails",
          query: {
            id: item.noticeId,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.messageBox {
  // border: 1px solid #E5E5E5;
  padding: 30px;
  .messageList {
    .itemBox {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 30px;
      padding-bottom: 20px;
      .icon {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #348bfa;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 26px;
        margin-right: 30px;
      }
      .color {
        background: #f75c61;
      }
      .messageTitle {
        h3 {
          color: #333333;
          font-size: 14px;
          margin-bottom: 20px;
          cursor: pointer;
        }
        span {
          color: #666666;
          font-size: 12px;
        }
      }
    }
  }
}
.sub-main {
  min-height: 400px;
}
.nothing {
  width: 100%;
  text-align: center;
  min-height: 400px;
  p {
    margin-bottom: 20px;
  }

  //   .el-button {
  //     background-color: #ff7800;
  //     color: #ffffff;
  //     font-weight: normal;
  //     border-radius: 0;
  //   }
}
.el-table tr {
    background-color: #F1F2F7 !important;
}
.btn {
  border: 1px solid #e5e5e4 !important;
  font-size: 14px;
  outline: none;
  color: #999999 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/billPayServer/billPayServer.vue